export default {
	alarm_action_failed: 'Die Erinnerung konnte nicht bestätigt werden. Bitte erneut versuchen.',
	alarm_action_notification_cleanup_failed:
		'Die Erinnerung wurde bestätigt, die Gerätebenachrichtigung konnte aber nicht aktualisiert werden.',
	alarm_appointment: 'Denken Sie an Ihren Termin',
	alarm_custom_date: 'Zu einem genauen Zeitpunkt',
	alarm_date_label: 'Datum',
	alarm_invalid_date_past: 'Bitte wählen Sie eine Zeit in der Zukunft',
	alarm_remind_again_label: 'Erneut erinnern in...',
	alarm_remind_at_label: 'Erinnern um...',
	alarm_remind_in_label: 'Erinnern in...',
	alarm_reminder_title: 'Erinnerung',
	alarm_reminder_title_appointment: 'Erinnerung an Ihren Termin',
	alarm_reminder_title_task: 'Erinnerung an Ihre Aufgabe',
	alarm_show: 'Anzeigen',
	alarm_snooze_1_day: 'In 1 Tag',
	alarm_snooze_1_hour: 'In 1 Stunde',
	alarm_snooze_2_hours: 'In 2 Stunden',
	alarm_snooze_4_hours: 'In 4 Stunden',
	alarm_snooze_5_min: 'In 5 Minuten',
	alarm_snooze_15_min: 'In 15 Minuten',
	alarm_snooze_30_min: 'In 30 Minuten',
	alarm_snooze_ok: 'Ok',
	alarm_task: 'Denken Sie an Ihre Aufgabe',
	alarm_time_label: 'Uhrzeit',
	alarm_time_suffix: 'Uhr',
	alarm_title_label: 'Titel',
};
